import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FEDERATION } from '@/lib/api';

export default function Header() {
  const navigate = useNavigate();
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-2xl border-b border-white/10"
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo">
          <span className="h-9 w-9 border border-[#CCFF00]/70 flex items-center justify-center font-display text-sm text-[#CCFF00]">P</span>
          <div className="flex flex-col leading-none">
            <span className="font-display text-sm md:text-base uppercase tracking-wider">Players</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">Sports Federation</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7 font-mono text-xs uppercase tracking-[0.2em]">
          <Link to="/" className="text-white/70 hover:text-white transition-colors" data-testid="nav-home">Home</Link>
          <Link to="/live" className="text-white/70 hover:text-white transition-colors flex items-center gap-2" data-testid="nav-live">
            <span className="h-1.5 w-1.5 rounded-full bg-[#FF3B30] animate-pulse" />Live
          </Link>
          <Link to="/track" className="text-white/70 hover:text-white transition-colors" data-testid="nav-track">Track</Link>
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/register')}
            className="text-xs font-mono uppercase tracking-widest px-5 py-2 bg-[#CCFF00] text-black hover:bg-white transition-colors"
            data-testid="header-register"
          >
            Register Now
          </button>
        </div>
      </div>
    </motion.header>
  );
}
